import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { PrincipalBannerAppMovil } from './app-movil-components/principal-banner-app-movil';
import { ComoMeUnoAlPrograma } from './app-movil-components/como-unirse';
import { FeaturesAppMovil } from './app-movil-components/features-app-movil';
import { PorqueUsarLaApp } from './app-movil-components/porque-usar-la-app';
import { DownloadAppButtons } from '../../components/shared/download-app-buttons';

@Component({
  selector: 'allas-home',
  imports: [
    MainLayout,
    PrincipalBannerAppMovil,
    ComoMeUnoAlPrograma,
    FeaturesAppMovil,
    PorqueUsarLaApp,
    DownloadAppButtons,
  ],
  template: `
    <allas-main-layout>
      <div class="bg-white w-full max-w-[1600px] mx-auto px-2 xl:px-4 2xl:px-0">
        <!-- Titulo APP MOVIL -->
        <h1 class="text-2xl xl:text-4xl my-2 xl:my-4 font-medium fs-condensed">
          APP MOVIL
        </h1>

        <!-- Banner de la App -->
        <allas-principal-banner-app-movil />

        <!-- Texto de Como me Uno -->
        <allas-como-me-uno-al-programa />

        <!-- Features de la App -->
        <allas-features-app-movil />

        <!-- Titulo de Porque usar la App -->
        <h2
          class="text-xl xl:text-4xl mb-2 xl:mb-12 mt-12 xl:mt-24 w-full text-center font-medium fs-condensed"
        >
          ¿Por qué usar nuestra App?
        </h2>

        <!-- Porque usar la App -->
        <allas-porque-usar-la-app />

        <!-- DESCARGA LA APP -->
        <section
          class="my-12 xl:my-28 text-center flex flex-col gap-4 items-center justify-center mx-auto w-full xl:max-w-screen-lg"
        >
          <span class="font-bold text-5xl xl:text-7xl fs-condensed">
            ¡DESCARGA LA APP ALLAS REPUESTOS AHORA!
          </span>
          <allas-download-app-buttons spanGapStyleClass="gap-4" />
        </section>
      </div>
    </allas-main-layout>
  `,
})
export class AplicacionMovil implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle =
      'App Móvil Allas Repuestos | Tu Tienda de Repuestos en la Palma de tu Mano';
    const description =
      'Descarga la app móvil de Allas Repuestos. Administra tu garaje, registra garantías, obtén recompensas y compra repuestos con envío a domicilio en Honduras.';
    const keywords =
      'app móvil, Allas Repuestos, repuestos, aplicación móvil, garaje, garantía, recompensas, cotización, escaneo VIN, compra en línea, envío a domicilio, Honduras';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
